export enum ComponentTypes {
  FreeText = 1,
  SingleChoice = 2,
  MultipleChoice = 3,
  NumericRange = 4,
  NumericValue = 5,
  YesNo = 6,
  PainLocationChart = 7,
  Ranking = 8,
  Information = 9,
  Section = 10,
  FileRequest = 11,
  DateRequest = 12,
  Bmi = 13,
  BloodPressure = 14,
}
